import { FC, useEffect, useState } from "react";
import axios from "axios";
import { URL } from '../../../redux/common/url';
import { toast } from "react-toastify";
import { handleCSVNew, handlePDFNew, handleExcelNew } from '../Provisional/print';
import moment from 'moment';
import { Link } from "react-router-dom";
import clsx from "clsx";
import { AsyncPaginate } from "react-select-async-paginate";
import ReactPaginate from "react-paginate";

interface Value {
  id: string
  name: string
};

interface Option {
  value: string
  label: string
};

interface PaginatedResponse {
  results: Option[]
  has_more: boolean
};

 const reportColumns = [
    { label: "S.NO.", key: "serialNumber" },
    { label: "Job Id", key: "id" },
     { label: "Vendor", key: "vendorName" },
    { label: "Pickup location", key: "source_hydrant_center.address" },
    { label: "Drop location", key: "destination.address" },
    { label: "Pickup Date", key: "accepted_time" },
    { label: "Pickup time", key: "accepted_time" },
    { label: "End Date", key: "complete_time" },
    { label: "End time", key: "complete_time" },
    { label: "Trip Duration", key: "trip_duration" },
    { label: "Name", key: "user.name" },
    { label: "Number", key: "user.mobile" },
    { label: "Tanker Number", key: "vehicle.registration_number" },
    { label: "Distance", key: "total_distance" },
    { label: "Amount", key: "amount" },
    { label: "Remarks", key: "remark" }
];

const Vef_Vendor: FC = () => {
  const [vendor, setVendor] = useState<any[]>([])
  const [vehicle, setVehicle] = useState<any[]>([])
  const [circles, setCircles] = useState<Value[]>([])
  const [reportData, setReportData] = useState([])
  const [page, setPage] = useState<number>(1)
  const [vendorId, setVendorId] = useState<string>('')
  const [vehicleId, setVehicleId] = useState<string>('')
  const [fromDate, setFromDate] = useState<string>('')
  const [toDate, setToDate] = useState<string>('')
  const [name, setName] = useState<string>('')
  const [circle_id, setCircle_id] = useState('')
  const [pageNo, setpageNo] = useState<any>(1)
  const [pageCount, setPageCount] = useState(0)

  // XEN / AEN / JEN filters
  const [seleceteMangerXenForFilters, setseleceteMangerXenForFilters] = useState<any>({})
  const [seleceteMangerAenForFilters, setseleceteMangerAenForFilters] = useState<any>({})
  const [seleceteMangerJenForFilters, setseleceteMangerJenForFilters] = useState<any>({})

  const [managerKey, setManagerKey] = useState(0)
  const [managerKeyAen, setManagerKeyAen] = useState(0)
  const [managerKeyJen, setManagerKeyJen] = useState(0)


  const user = JSON.parse(localStorage.getItem('access_admin_token')!).data

  useEffect(() => {
    fetchCircles()
    getReports()
  }, [pageNo])
  const totalAmount = reportData?.reduce((acc: any, curr: any) => acc + curr.amount, 0)

  const fetchVehicles = async (vendorId: string) => {
    try {
      setVendorId(vendorId)
      const res = await axios.get(
        `${URL.API_BASE_URL}${URL.all_vendors_tanker}?vendor_id=${vendorId}&page=1`
      )
      if (res?.data?.results) {
        setVehicle(res?.data?.results)
      }
    } catch (error) {
      console.error(error)
    }
  };

  const handlePageClick = (event: any) => {
    // const newOffset = event.selected % (comments.length / 2);
    // setCurrentPage(newOffset + 1);
    // setItemOffset(newOffset * itemsPerPage);
    const data = event?.selected + 1
    setpageNo(data)
    // if (!userSearch) {
    // dispatch(adminAction.getCurrentBookings(data))
    return () => { }
    // } else {
    //   dispatch(
    //     ShoetoggelAction.searchUser({ pageNumber: data, key: userSearch })
    //   );

    //   return () => {};
    // };
  };

  const fetchCircles = async () => {
    try {
      const response = await axios.get(`${URL.API_BASE_URL + URL.getAllCircles}`)
      if (response?.data?.data) {
        setCircles(response?.data?.data)
      }
    } catch (error) {
      console.error(error)
    }
  };

  const fetchVendors = async (circleId: string) => {
    setCircle_id(circleId);
    setseleceteMangerXenForFilters({})
    setseleceteMangerAenForFilters({})
    setseleceteMangerJenForFilters({})

    setManagerKey(k => k + 1)
    setManagerKeyAen(k => k + 1)
    setManagerKeyJen(k => k + 1)

    setVendorId('')
    setVehicleId('')
    setpageNo(1)
    // 
    // try {
    //   const res = await axios.get(`${URL.API_BASE_URL}${URL.getVendorList}?circle_id=${circleId}`)
    //   if (res?.data?.results) {
    //     setVendor(res?.data?.results)
    //   }
    // } catch (error) {
    //   console.error(error)
    // }
  };

  const getReports = async () => {
    try {
      const token = JSON.parse(localStorage.getItem('kt-auth-react-v')!)
      const config = {
        headers: {
          Authorization: 'Bearer ' + token.api_token,
        },
      }

      const query = [
        `approved=accept`,
        `page=${pageNo}`,
        seleceteMangerXenForFilters?.id && `xen_id=${seleceteMangerXenForFilters.id}`,
        seleceteMangerAenForFilters?.id && `aen_id=${seleceteMangerAenForFilters.id}`,
        seleceteMangerJenForFilters?.id && `jen_id=${seleceteMangerJenForFilters.id}`,
        vendorId && `vendor=${vendorId}`,
        vehicleId && `vehicle=${vehicleId}`,
        fromDate && `fromdate=${moment(fromDate).format('YYYY-MM-DD')}`,
        toDate && `todate=${moment(toDate).format('YYYY-MM-DD')}`,
        name && `search=${name}`,
      ]
        .filter(Boolean)
        .join('&')

      const res = await axios.get(`${URL.API_BASE_URL}${URL.getReports}?${query}`, config)

      if (res?.data?.data?.data) {
        setReportData(res?.data?.data?.data)
        // setPage(res?.data?.data?.current_page)
        setPageCount(Math.ceil(res?.data?.data?.total / 50))
      }
    } catch (error: any) {
      toast.error(error?.response?.data?.message)
    }
  };

  const loadOptionsgetManagerXenForFilters = async (
    search: any,
    loadedOptions: any,
    { page }: any
  ) => {
    if (!circle_id) return { options: [], hasMore: false }

    const token: any = localStorage.getItem('kt-auth-react-v')

    const response = await fetch(
      `${URL.API_BASE_URL}/api/admins/get_all_xen?search=${search}&page=${page}&circle_id=${circle_id}`,
      {
        headers: {
          Authorization: `Bearer ${JSON.parse(token!).api_token}`,
        },
      }
    )

    const responseJSON = await response.json()

    return {
      options: responseJSON?.results?.map((d: any) => ({
        ...d,
        value: d.id,
        label: d.name,
      })) || [],
      hasMore: responseJSON.has_more,
      additional: { page: page + 1 },
    }
  }

  const loadOptionsgetManagerAenForFilters = async (
    search: any,
    loadedOptions: any,
    { page }: any
  ) => {
    if (!seleceteMangerXenForFilters?.id) {
      return { options: [], hasMore: false }
    }

    const token: any = localStorage.getItem('kt-auth-react-v')

    const response = await fetch(
      `${URL.API_BASE_URL}/api/admins/get_department_child?search=${search}&page=${page}&id=${seleceteMangerXenForFilters.id}&circle_id=${circle_id}`,
      {
        headers: {
          Authorization: `Bearer ${JSON.parse(token!).api_token}`,
        },
      }
    )

    const responseJSON = await response.json()

    return {
      options: responseJSON?.results?.map((d: any) => ({
        ...d,
        value: d.id,
        label: d.name,
      })) || [],
      hasMore: responseJSON.has_more,
      additional: { page: page + 1 },
    }
  }

  const loadOptionsgetManagerJenForFilters = async (
    search: any,
    loadedOptions: any,
    { page }: any
  ) => {
    if (!seleceteMangerAenForFilters?.id) {
      return { options: [], hasMore: false }
    }

    const token: any = localStorage.getItem('kt-auth-react-v')

    const response = await fetch(
      `${URL.API_BASE_URL}/api/admins/get_department_child?search=${search}&page=${page}&id=${seleceteMangerAenForFilters.id}&circle_id=${circle_id}`,
      {
        headers: {
          Authorization: `Bearer ${JSON.parse(token!).api_token}`,
        },
      }
    )

    const responseJSON = await response.json()

    return {
      options: responseJSON?.results?.map((d: any) => ({
        ...d,
        value: d.id,
        label: d.name,
      })) || [],
      hasMore: responseJSON.has_more,
      additional: { page: page + 1 },
    }
  }

  const loadOptionsVendor = async (search: any, loadedOptions: any, { page }: { page: any, }) => {
    const token: any = await localStorage.getItem('kt-auth-react-v');

    let url = `${URL.getVendorList}?circle_id=${circle_id}`;
    if (seleceteMangerJenForFilters?.id) {
      url += `&jen_id=${seleceteMangerJenForFilters.id}`
    }
    const response = await fetch(`${URL.API_BASE_URL + url}&page=${page}&search=${search}`,
      {
        headers: {
          Authorization: `Bearer ${JSON.parse(token).api_token}`,
        },
      }
    );
    const responseJSON: PaginatedResponse = await response.json();
    const options: any = responseJSON?.results?.map((data: any) => {
      data.value = data?.id;
      data.label = data?.name;
      return data;
    });

    return {
      options: options,
      hasMore: responseJSON.has_more,
      additional: {
        page: page + 1,
      },
    }
  };

  const loadOptionsVehicle = async (search: any, loadedOptions: any, { page }: { page: any }) => {
    const token: any = await localStorage.getItem('kt-auth-react-v');

    let url = `${URL.all_vendors_tanker}?vendor_id=${vendorId}`;

    const response = await fetch(`${URL.API_BASE_URL + url}&page=${page}&search=${search}`,
      {
        headers: {
          Authorization: `Bearer ${JSON.parse(token).api_token}`,
        },
      }
    );
    const responseJSON: PaginatedResponse = await response.json();
    const options: any = responseJSON?.results?.map((data: any) => {
      data.value = data?.vehicle_id;
      data.label = data?.vehicle?.registration_number;
      return data;
    });
    return {
      options: options,
      hasMore: responseJSON.has_more,
      additional: {
        page: page + 1,
      },
    }
  };

  const handleDownload = async () => {
    try {
      const token: any = await localStorage.getItem('kt-auth-react-v')
      const config = {
        headers: {
          Authorization: 'Bearer ' + JSON.parse(token).api_token,
        },
      }

      const query = [
        `approved=accept`,
        seleceteMangerXenForFilters?.id && `xen_id=${seleceteMangerXenForFilters.id}`,
        seleceteMangerAenForFilters?.id && `aen_id=${seleceteMangerAenForFilters.id}`,
        seleceteMangerJenForFilters?.id && `jen_id=${seleceteMangerJenForFilters.id}`,
        vendorId && `vendor=${vendorId}`,
        vehicleId && `vehicle=${vehicleId}`,
        fromDate && `fromdate=${moment(fromDate).format('YYYY-MM-DD')}`,
        toDate && `todate=${moment(toDate).format('YYYY-MM-DD')}`,
        name && `search=${name}`,
      ]
        .filter(Boolean)
        .join('&')

      const res = await axios.get(
        `${URL.API_BASE_URL}${URL.downloadReports}?${query}`, config);
    if (res?.data?.data) {
      const modifiedData = res.data.data.map((item: any, index: number) => ({
        ...item,
        serialNumber: index + 1,
        vendorName: item?.vendor?.user_name || 'N/A', // ✅ THIS FIX
      }))

      return modifiedData
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message)
  }
};

  return (
    <div>
      <div className='d-flex justify-content-between'>
        <h3 className='text-gray-600'>Trip Report Vendor Wise</h3>
        <p>
          <span className='text-primary'>Home</span> / Trip Report Vendor Wise
        </p>
      </div>

      <div className="bg-transparent shadow p-4 rounded-3">
        <div className="row g-3 align-items-end">

          {/* Circle */}
          <div className="col-md-2">
            <label className="form-label fw-bold">Circle</label>
            <select
              className="form-control"
              name="circle_id"
              onChange={(e: any) => fetchVendors(e.target.value)}
            >
              <option value="">Select Circle</option>
              {circles.map((data, i) => (
                <option value={data.id} key={i}>
                  {data.name}
                </option>
              ))}
            </select>
          </div>

          {/* XEN */}
          <div className="col-md-2">
            <label className="form-label fw-bold">Select XEN</label>
            <AsyncPaginate
              key={managerKey}
              value={seleceteMangerXenForFilters}
              loadOptions={loadOptionsgetManagerXenForFilters}
              onChange={(e: any) => {
                setseleceteMangerXenForFilters(e)
                setseleceteMangerAenForFilters({})
                setseleceteMangerJenForFilters({})
                setManagerKeyAen(k => k + 1)
                setManagerKeyJen(k => k + 1)
                setVendorId('')
                setVehicleId('')
                setpageNo(1)
              }}
              additional={{ page: 1 }}
              classNamePrefix="react-select"
            />
          </div>

          {/* AEN */}
          <div className="col-md-2">
            <label className="form-label fw-bold">Select AEN</label>
            <AsyncPaginate
              key={managerKeyAen}
              value={seleceteMangerAenForFilters}
              loadOptions={loadOptionsgetManagerAenForFilters}
              onChange={(e: any) => {
                setseleceteMangerAenForFilters(e)
                setseleceteMangerJenForFilters({})
                setManagerKeyJen(k => k + 1)
                setVendorId('')
                setVehicleId('')
                setpageNo(1)
              }}
              additional={{ page: 1 }}
              classNamePrefix="react-select"
            />
          </div>

          {/* JEN */}
          <div className="col-md-2">
            <label className="form-label fw-bold">Select JEN</label>
            <AsyncPaginate
              key={managerKeyJen}
              value={seleceteMangerJenForFilters}
              loadOptions={loadOptionsgetManagerJenForFilters}
              onChange={(e: any) => {
                setseleceteMangerJenForFilters(e)
                setVendorId('')
                setVehicleId('')
                setpageNo(1)
              }}
              additional={{ page: 1 }}
              classNamePrefix="react-select"
            />
          </div>

          {/* Vendor */}
          <div className="col-md-2">
            <label className="form-label fw-bold">Vendor</label>
            <AsyncPaginate
              key={`${circle_id}-${seleceteMangerJenForFilters?.id || 'no-jen'}`}
              loadOptions={loadOptionsVendor}
              onChange={(item: any) => setVendorId(item?.value)}
              additional={{ page: 1 }}
              classNamePrefix="react-select"
            />
          </div>

          {/* Vehicle */}
          <div className="col-md-2">
            <label className="form-label fw-bold">Vehicle</label>
            <AsyncPaginate
              key={vendorId}
              loadOptions={loadOptionsVehicle}
              onChange={(e: any) => setVehicleId(e?.vehicle_id)}
              additional={{ page: 1 }}
              classNamePrefix="react-select"
            />
          </div>

          {/* Date From */}
          <div className="col-md-2">
            <label className="form-label fw-bold">Date From</label>
            <input
              type="date"
              className="form-control"
              onChange={(e: any) => setFromDate(e.target.value)}
            />
          </div>

          {/* Date To */}
          <div className="col-md-2">
            <label className="form-label fw-bold">Date To</label>
            <input
              type="date"
              className="form-control"
              onChange={(e: any) => setToDate(e.target.value)}
            />
          </div>

          {/* View Button */}
          <div className="col-md-2">
            <button
              className="btn w-100 text-white"
              style={{ backgroundColor: "#52A841" }}
              onClick={() => getReports()}
            >
              View
            </button>
          </div>
        </div>


        
        <div className='d-flex align-items-center justify-content-between gap-4 mt-4 px-5'>
          <div className='d-flex gap-1'>
            {/* <div
              className='p-2'
              style={{ border: '1px solid #000', backgroundColor: '#ADAFAD', cursor: 'pointer' }}
              onClick={async () => {
                const data = await handleDownload();
                if (!data || !Array.isArray(data)) {
                  alert("No data available to copy");
                  return;
                }
                handleCopy(data);
              }}
            >
              Copy
            </div> */}
            <div
              className='p-2'
              style={{ border: '1px solid #000', backgroundColor: '#ADAFAD', cursor: 'pointer' }}
              onClick={async () => {
                const data = await handleDownload();
                handleCSVNew(data, reportColumns, "Report Vendor Wise", fromDate, toDate)
              }}
            >
              CSV
            </div>
            <div
              className='p-2'
              style={{ border: '1px solid #000', backgroundColor: '#ADAFAD', cursor: 'pointer' }}
              onClick={async () => {
                const data = await handleDownload();
                handlePDFNew(data, reportColumns, "Report Vendor Wise", fromDate, toDate)
              }}
            >
              PDF
            </div>
            <div
              className='p-2'
              style={{ border: '1px solid #000', backgroundColor: '#ADAFAD', cursor: 'pointer' }}
              onClick={async () => {
                const data = await handleDownload();
                handleExcelNew(data, reportColumns, "Report Vendor Wise", fromDate, toDate)
              }}
            >
              EXCEL
            </div>
          </div>

          {/* Search Field */}
          <div>
            <input
              type='search'
              placeholder='Search by Name'
              className='form-control'
              onChange={(e: any) => setName(e.target.value)}
            />
          </div>
        </div>

        {/* Pagination Table  */}
        <div className='mt-9'>
          <table className='table' style={{ fontSize: '12px', fontWeight: '300' }}>
            <thead className='table-light'>
              <tr>
                <th>S.NO.</th>
                <th>Job Id</th>
                <th>Vendor</th>
                <th>Pickup location</th>
                <th>Drop location</th>
                <th>Pickup Date / time</th>
                <th>End Date / time</th>
                <th>Trip Duration</th>
                <th>Name</th>
                <th>Number</th>
                <th>Tanker Number</th>
                <th>Distance</th>
                <th>Amount</th>
                <th>Remarks</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody style={{ maxHeight: '60vh', overflow: 'auto' }}>
              {reportData.length > 0 &&
                reportData.map((item: any, index: any) => (
                  <tr key={index}>
                    <td> {(pageNo - 1) * 50 + index + 1} </td>
                    <td>{item?.id}</td>
                    <td>{item?.vendor?.user_name}</td>
                    <td>{item?.source_hydrant_center?.address}</td>
                    <td>{item?.destination?.address}</td>
                    <td>{item?.accepted_time}</td>
                    <td>{item?.complete_time}</td>
                    <td>{item?.trip_duration}</td>
                    <td>{item?.user?.name}</td>
                    <td>{item?.user?.mobile}</td>
                    <td>{item?.vehicle?.registration_number}</td>
                    <td>{item?.total_distance}</td>
                    <td>{item?.amount}</td>
                    <td>{item?.remark}</td>
                    <td>
                      <Link to={`/view_details/${item?.id}/accept`}>
                        <button className='btn-group btn-group-sm bg-primary text-white'>
                          View Details
                        </button>
                      </Link>
                    </td>
                  </tr>
                ))}
            </tbody>

            <tfoot>
              <tr>
                <td colSpan={6}></td>
                <td>
                  <b>Date</b>
                </td>
                <td> {fromDate ? fromDate : "--"} to{toDate ? toDate : "--"}</td>
                <td colSpan={2}></td>
                <td>
                  <b>Total</b>
                </td>
                <td colSpan={2} className='text-center fs-5'>
                  {totalAmount}
                </td>
                <td></td>
              </tr>
              <tr>
                <td colSpan={14} style={{ textAlign: 'center' }}>
                  This is System Generated Report it does not require any signature or stamp.
                </td>
              </tr>
            </tfoot>
          </table>
          {/* <p>Showing 1 to 201 of 201 entries</p> */}
          <div style={{ height: '45px' }}>
            <ReactPaginate
              breakLabel='...'
              nextLabel='next'
              className='dataTables_paginate paging_simple_numbers category'
              onPageChange={handlePageClick}
              pageRangeDisplayed={2}
              pageCount={pageCount}
              previousLabel='previous'
            // renderOnZeroPageCount={null}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Vef_Vendor
